import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ExploreOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"explore_off"}/>
}
